// extracted by mini-css-extract-plugin
module.exports = {"section":"section__2mnWs","thumbnail-wrapper":"thumbnail-wrapper__2-z35","thumbnail":"thumbnail__2ugoz","text":"text__3Zhr9"};